export default __webpack_public_path__ + "94dfb10d07f465f4b1c5d65a2a819891.png";